import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { HorarioService } from 'src/app/services/horario.service';

@Component({
  selector: 'app-create-edit-horario',
  templateUrl: './create-edit-horario.component.html',
  styleUrls: ['./create-edit-horario.component.scss']
})
export class CreateEditHorarioComponent implements OnInit {
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt='Crear horario'
  public lstDisciplinas: any;
  public lstClubes: any;


  constructor(
    private disciplinaSvc: DisciplinaService,
    public horarioSvc: HorarioService,
    public empresaSvc: EmpresaService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEditHorarioComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt='Editar horario'
    }
  }

  ngOnInit(): void {
    this.disciplinaSvc.getDisciplinasDropdown().subscribe(disLst=>{
      console.log(disLst);
      this.lstDisciplinas=disLst;
    })

    this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
      console.log(clubLst);
      this.lstClubes = clubLst;
    });

  this.inicarFormulario();

  }
inicarFormulario(){
  this.registerForm = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    nombre: new UntypedFormControl('', Validators.required),
    lunes: new UntypedFormControl('', Validators.required),
    martes: new UntypedFormControl('', Validators.required),
    miercoles: new UntypedFormControl('', Validators.required),
    jueves: new UntypedFormControl('', Validators.required),
    viernes: new UntypedFormControl('', Validators.required),
    sabado: new UntypedFormControl('', Validators.required),
    domingo: new UntypedFormControl('', Validators.required),
    horaInicio: new UntypedFormControl('', Validators.required),
    horaFin: new UntypedFormControl('', Validators.required),
    disciplinaId: new UntypedFormControl('', Validators.required),
    habilitado: new UntypedFormControl('', Validators.required),
    disciplina: new UntypedFormControl(''),
    empresaId: new UntypedFormControl('', Validators.required),
    aforo: new UntypedFormControl('', Validators.required),
    piscina: new UntypedFormControl('', Validators.required),
    
  });
//  this.registerForm.get('id')?.setValue(this.dataInput.id);
  this.registerForm.get('habilitado')?.setValue(false);
  this.registerForm.get('lunes')?.setValue(true);
  this.registerForm.get('martes')?.setValue(true);
  this.registerForm.get('miercoles')?.setValue(true);
  this.registerForm.get('jueves')?.setValue(true);
  this.registerForm.get('viernes')?.setValue(true);
  this.registerForm.get('sabado')?.setValue(true);
  this.registerForm.get('domingo')?.setValue(true);

  if (this.isForEdit) {

    this.horarioSvc.getHorario(this.data.id).subscribe(result=>{
      console.log('El horario es: ', result);
      this.registerForm.get('id')?.setValue(result.id);
      this.registerForm.get('nombre')?.setValue(result.nombre);
      this.registerForm.get('disciplinaId')?.setValue(result.disciplinaId);
      this.registerForm.get('lunes')?.setValue(result.lunes);
      this.registerForm.get('martes')?.setValue(result.martes);
      this.registerForm.get('miercoles')?.setValue(result.miercoles);
      this.registerForm.get('jueves')?.setValue(result.jueves);
      this.registerForm.get('viernes')?.setValue(result.viernes);
      this.registerForm.get('sabado')?.setValue(result.sabado);
      this.registerForm.get('domingo')?.setValue(result.domingo);
      this.registerForm.get('horaInicio')?.setValue(result.horaInicio);
      this.registerForm.get('horaFin')?.setValue(result.horaFin);
      this.registerForm.get('empresaId')?.setValue(result.empresaId);
      this.registerForm.get('habilitado')?.setValue(result.habilitado);
      this.registerForm.get('aforo')?.setValue(result.aforo);
       this.registerForm.get('piscina')?.setValue(result.piscina);
      
    })

  }else{
    console.log('entra al elseeee')
  }

}


  guardar() {
    console.log('guardar horario');
    console.log(this.registerForm.value);
    if (this.isForEdit) {
      //aqui mando a editar
      this.horarioSvc
        .editHorario(this.registerForm.value)
        .subscribe((res) => {
          console.log('resultado Editar: ', res);
          if (res) {
            this.alertify.success('Horario actualizado');
            this.dialogRef.close();
          } else {
            this.alertify.error('El horario no se ha podido actualizar');
          }
        });
    } else {
      //aqui mando a crearlo
      this.registerForm
        .get('id')
        ?.setValue('00000000-0000-0000-0000-000000000000');
        this.registerForm.get('disciplina')?.setValue('');

        //https://stackoverflow.com/questions/3232701/using-json-to-serialize-deserialize-timespan
        this.registerForm.get('horaInicio')?.setValue(this.registerForm.value.horaInicio+':00');
        this.registerForm.get('horaFin')?.setValue(this.registerForm.value.horaFin+':00')
      this.horarioSvc
        .addHorario(this.registerForm.value)
        .subscribe((res) => {
          console.log('resultado crear: ', res);
          if (res) {
            this.alertify.success('Horario creado');
            this.dialogRef.close();
          } else {
            this.alertify.error(
              'El horario no sew ha podido crear'
            );
          }
        });
    }
  }


  estado(){

    console.log(this.registerForm.value)
  }

}
